// extracted by mini-css-extract-plugin
export default {"color-upload":"upload-button_color-upload__wMT8M"};